/* ==========================================================================
   mxm-tallas.js — Selector de talla para las páginas de COLECCIÓN.

   Qué hace: la clienta toca su talla y las prendas que no la tienen se apagan
   con la etiqueta "Sin talla X". No las esconde: así no rompe la paginación ni
   el conteo de la grilla nativa de Dawn.

   POR QUÉ NO SE USA EL FILTRO NATIVO DE SHOPIFY (verificado 2026-08-02):
   la faceta de talla está armada sobre la taxonomía (filter.v.t.shopify.size),
   que significa "este producto viene en talla 40", NO "hay stock en talla 40".
   Filtrando Ultra Push Up por talla 40 devolvía EZ2526, EZ2520 y EZ2529, los
   tres con CERO unidades en esa talla. Combinarlo con filter.v.availability
   tampoco lo arregla. Por eso la disponibilidad real se lee de products.json.

   Rendimiento: el JSON de la colección se pide SOLO al primer toque de un chip,
   no en la carga de la página.

   OJO AL EDITAR: nada de expresiones regulares con barras escapadas acá. Este
   archivo se sube por GraphQL con block string, donde la barra invertida doble
   queda literal y rompe la regex (y con ella TODO el archivo, por SyntaxError).
   Usar split().
   ========================================================================== */
(function () {
  'use strict';

  function iniciar(raiz) {
    if (raiz.dataset.listo) return;
    raiz.dataset.listo = '1';

    var handle = raiz.dataset.coleccion;
    var chips = raiz.querySelector('[data-chips]');
    var cuenta = raiz.querySelector('[data-cuenta]');
    if (!handle || !chips) return;

    var disponibilidad = null;   // { handleProducto: { talla: true } }
    var cargando = false;
    var elegida = null;

    function grilla() {
      return document.querySelector('#product-grid, ul.product-grid');
    }

    function tarjetas() {
      var g = grilla();
      return g ? [].slice.call(g.querySelectorAll('li.grid__item, .grid__item')) : [];
    }

    function handleDeTarjeta(li) {
      var a = li.querySelector('a[href*="/products/"]');
      if (!a) return null;
      var partes = (a.getAttribute('href') || '').split('/products/');
      if (!partes[1]) return null;
      return partes[1].split('?')[0].split('#')[0].split('/')[0];
    }

    function esNombreTalla(nombre) {
      var n = String(nombre || '').toLowerCase();
      return n.indexOf('talla') !== -1 || n.indexOf('size') !== -1;
    }

    function indiceTalla(producto) {
      var ops = producto.options || [];
      for (var i = 0; i < ops.length; i++) {
        var o = ops[i];
        var nom = o && o.name ? o.name : o;
        if (esNombreTalla(nom)) return i;
      }
      return 0;
    }

    function cargar() {
      if (disponibilidad || cargando) return Promise.resolve();
      cargando = true;
      var acumulado = {};
      function pagina(n) {
        return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n, {
          headers: { Accept: 'application/json' },
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var prods = (data && data.products) || [];
            prods.forEach(function (p) {
              var idx = indiceTalla(p);
              var mapa = {};
              (p.variants || []).forEach(function (v) {
                if (!v.available) return;
                var talla = [v.option1, v.option2, v.option3][idx];
                if (talla) mapa[String(talla)] = true;
              });
              acumulado[p.handle] = mapa;
            });
            if (prods.length === 250 && n < 3) return pagina(n + 1);
          });
      }
      return pagina(1)
        .then(function () { disponibilidad = acumulado; cargando = false; })
        .catch(function () { cargando = false; });
    }

    function aplicar() {
      var lis = tarjetas();
      if (!lis.length) return;

      if (!elegida) {
        lis.forEach(function (li) {
          li.classList.remove('mxm-t--off');
          var av = li.querySelector('.mxm-t__aviso');
          if (av) av.remove();
        });
        if (cuenta) cuenta.textContent = '';
        return;
      }

      var conStock = 0;
      lis.forEach(function (li) {
        var h = handleDeTarjeta(li);
        var mapa = h && disponibilidad ? disponibilidad[h] : null;
        // Sin dato del producto NO se apaga: mejor mostrar de más que esconder
        // algo que sí se puede comprar.
        var hay = !mapa || mapa[elegida] === true;
        li.classList.toggle('mxm-t--off', !hay);

        var av = li.querySelector('.mxm-t__aviso');
        if (!hay) {
          if (!av) {
            av = document.createElement('span');
            av.className = 'mxm-t__aviso';
            // Hijo DIRECTO del <li> a propósito: el apagado se aplica a los
            // hermanos, no al <li>, así este cartel queda legible. Si se cuelga
            // dentro de .card, hereda la opacidad del padre y no se lee.
            li.appendChild(av);
          }
          av.textContent = 'Sin talla ' + elegida;
        } else if (av) {
          av.remove();
        }
        if (hay) conStock++;
      });

      if (cuenta) {
        cuenta.textContent = conStock + ' de ' + lis.length + ' en talla ' + elegida;
      }
    }

    function pintarChips() {
      var botones = chips.querySelectorAll('.mxm-t__chip');
      [].forEach.call(botones, function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.talla === elegida));
      });
    }

    chips.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.mxm-t__chip') : null;
      if (!b) return;
      var t = b.dataset.talla;
      elegida = elegida === t ? null : t;
      pintarChips();
      if (!elegida) { aplicar(); return; }
      if (cuenta) cuenta.textContent = 'buscando…';
      cargar().then(aplicar);
    });

    // Dawn re-renderiza la grilla por AJAX al usar facetas, ordenar o paginar.
    // Sin esto, el apagado se pierde en cuanto la clienta toca un filtro.
    var g = grilla();
    if (g && 'MutationObserver' in window) {
      var pendiente = null;
      new MutationObserver(function () {
        clearTimeout(pendiente);
        pendiente = setTimeout(aplicar, 120);
      }).observe(g.parentNode || g, { childList: true, subtree: true });
    }
  }

  function arrancar() {
    var nodos = document.querySelectorAll('.mxm-t');
    [].forEach.call(nodos, iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', arrancar);
})();